angular.module('bmsApp.trugreen.inventory', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider
				.state('main.trugreen.inventory', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/inventory/templates/TGInventoryMain.html',
							controller: 'TGInventoryMainCtrl'
						}
					}
				})
				.state('main.trugreen.inventory.index', {
					url: '^/trugreen/inventory',
					views: {
						'content@main.trugreen.inventory': {
							templateUrl: 'ng/trugreen/inventory/templates/TGInventoryIndex.html',
							controller: 'TGInventoryIndexCtrl'
						},
						'side@main.trugreen.inventory': {
							templateUrl: "ng/trugreen/inventory/templates/sidebars/TGInventoryIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Inventory'}
				})
				.state('main.trugreen.inventory.index.add', {
					url: '^/trugreen/inventory/add',
					views: {
						'content@main.trugreen.inventory': {
							templateUrl: 'ng/trugreen/inventory/templates/TGInventorySave.html',
							controller: 'TGInventorySaveCtrl',
							controllerAs: 'InventorySave',
						},
						'side@main.trugreen.inventory': {
							templateUrl: "ng/trugreen/inventory/templates/sidebars/TGInventoryIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Add'}
				})
				.state('main.trugreen.inventory.index.edit', {
					url: '^/trugreen/inventory/edit/{inventoryId:int}',
					views: {
						'content@main.trugreen.inventory': {
							templateUrl: 'ng/trugreen/inventory/templates/TGInventorySave.html',
							controller: 'TGInventorySaveCtrl',
							controllerAs: 'InventorySave',
						},
						'side@main.trugreen.inventory': {
							templateUrl: "ng/trugreen/inventory/templates/sidebars/TGInventoryIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Update'}
				})
		}]);